import gql from "graphql-tag";

export interface Partner {
    id: string;
    content: {
        langCode: string;
        name: string;
    };
    url: string;
    imageUrl: string;
    rel?: string;
}

export interface AboutPageContent {
    metaTitle: string;
    metaDescription: string;
    title: string;
    _text: string;
    partnersTitle: string;
    awardsTitle: string;
    keywords?: string;
}

interface ProductAward {
    url: string | undefined;
    imgUrl: string;
    alt: string;
    rel?: string;
}

export interface GetAboutContentData<T> {
    staticContent: {
        id: string;
        content: T;
    };
    product: {
        awards: ProductAward[] | null;
    };
    partners: Partner[] | null;
}

export const GET_ABOUT_CONTENT = gql`
    query getAboutContent($langCode: LangCode) {
        staticContent(id: "sw-site-about") {
            id
            content(langCode: $langCode)
        }
        product(id: "star-walk-2") {
            awards {
                imgUrl
                alt
                url
            }
        }
        partners {
            id
            content {
                name
            }
            url
            imageUrl
        }
    }
`;
